import React from 'react';
import classNames from 'classnames';
import { Information } from '../Information';
import { useDeviceInfo } from '../../hooks/useDeviceInfo';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MagicLink = function MagicLink(_ref) {
  var email = _ref.email;
  var deviceInfo = useDeviceInfo();
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('flex justify-between', {
      'flex-col': deviceInfo.mobile
    }),
    children: [/*#__PURE__*/_jsx("img", {
      src: "https://subkit-images.s3.amazonaws.com/images/illo.svg",
      alt: "magic link",
      style: {
        height: deviceInfo.mobile ? 256 : 'auto'
      }
    }), /*#__PURE__*/_jsx("div", {
      className: classNames('flex items-center', {
        'pl-4 col-6': !deviceInfo.mobile,
        'col-12': deviceInfo.mobile
      }),
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Information, {
          heading: "Magic Link sent!",
          styles: {
            heading: 'text-2xl'
          }
        }), /*#__PURE__*/_jsxs("span", {
          className: "block my1",
          children: ["We just sent an email to you at: ", /*#__PURE__*/_jsx("span", {
            className: "bold",
            children: email
          })]
        }), /*#__PURE__*/_jsx("span", {
          className: "block mt2",
          children: "It contains a link that\u2019ll help you sign you in super quick. Please check your inbox."
        })]
      })
    })]
  });
};